var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackNotSubmitted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 43C33.598 43 43 33.598 43 22C43 10.402 33.598 1 22 1C10.402 1 1 10.402 1 22C1 33.598 10.402 43 22 43Z",
    stroke: "#55AA96",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5666 22.0008C32.7264 22.0008 33.6666 21.0606 33.6666 19.9008C33.6666 18.741 32.7264 17.8008 31.5666 17.8008C30.4068 17.8008 29.4666 18.741 29.4666 19.9008C29.4666 21.0606 30.4068 22.0008 31.5666 22.0008Z",
    fill: "#55AA96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4333 22.0008C13.593 22.0008 14.5333 21.0606 14.5333 19.9008C14.5333 18.741 13.593 17.8008 12.4333 17.8008C11.2735 17.8008 10.3333 18.741 10.3333 19.9008C10.3333 21.0606 11.2735 22.0008 12.4333 22.0008Z",
    fill: "#55AA96"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0046 28.0664C17.9166 33.7831 26.0833 33.7831 28.9953 28.0664",
    stroke: "#55AA96",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackNotSubmitted);
export default __webpack_public_path__ + "static/media/feedback_not_submitted.43dd7eab465f2fc2f19300e8ca14dc3d.svg";
export { ForwardRef as ReactComponent };